export default "__VITE_ASSET__B48$5bV2__"